import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../App';
import MsMark from './brand/MsMark';
import { InstagramIcon, TikTokIcon } from './brand/icons';
import '../styles/Footer.css';

const EMAIL = 'info@mstechs.cloud';
const PHONE_DISPLAY = '+381 66 9819 240';
const PHONE_HREF = '+381669819240';

export default function Footer() {
  const { getTranslation } = useContext(LanguageContext);
  const t = getTranslation('footer');
  const nav = getTranslation('navbar');

  return (
    <footer className="foot">
      <div className="foot__inner container">
        <div className="foot__grid">
          <div className="foot__brand-col">
            <Link to="/" className="foot__brand" aria-label="MS Technology — početna">
              <MsMark className="foot__mark" />
              <span>MS Technology</span>
            </Link>
            <p className="foot__tagline">{t.tagline}</p>
            <div className="foot__social">
              <a
                href="https://www.instagram.com/mstechs.cloud/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="foot__social-link"
              >
                <InstagramIcon />
              </a>
              <a
                href="https://www.tiktok.com/@ms.techs"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
                className="foot__social-link"
              >
                <TikTokIcon />
              </a>
            </div>
          </div>

          <nav className="foot__col" aria-label={t.services}>
            <h2 className="foot__head">{t.services}</h2>
            {/* Cetiri usluge, tacno onoliko koliko ih dizajn prikazuje na /usluge */}
            <ul>
              <li><Link to="/usluge#web">{t.webDev}</Link></li>
              <li><Link to="/usluge#mobilne">{t.mobileApps}</Link></li>
              <li><Link to="/usluge#drustvene">{t.socialMedia}</Link></li>
              <li><Link to="/usluge#meniji">{t.digitalMenus}</Link></li>
            </ul>
          </nav>

          <nav className="foot__col" aria-label={t.company}>
            <h2 className="foot__head">{t.company}</h2>
            <ul>
              <li><Link to="/nas-rad">{nav.portfolio}</Link></li>
              <li><Link to="/proces">{nav.process}</Link></li>
              <li><Link to="/cene">{nav.pricing}</Link></li>
              <li><Link to="/kontakt">{nav.contact}</Link></li>
            </ul>
          </nav>

          <div className="foot__col">
            <h2 className="foot__head">{t.contact}</h2>
            <ul>
              <li><a href={`mailto:${EMAIL}`}>{EMAIL}</a></li>
              <li><a href={`tel:${PHONE_HREF}`}>{PHONE_DISPLAY}</a></li>
              <li>
                <a href="https://mstechs.cloud" target="_blank" rel="noopener noreferrer">
                  mstechs.cloud
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="foot__bottom">
          <p>© {new Date().getFullYear()} MS Technology. {t.rights}</p>
          <p className="foot__made">{t.made}</p>
        </div>
      </div>
    </footer>
  );
}
